export default "__VITE_ASSET__Di6T9v9m__"